import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  TextField,
  InputAdornment,
  SvgIcon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  Popover
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';

const ToolbarSection = ({
  classes,
  STATUS_CONFIG,
  filterStatus,
  setFilterStatus,
  countsByStatus,
  searchInput,
  handleSearch,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  filterType,
  setFilterType,
  handleTypeChange,
  filterDevice,
  setFilterDevice,
  filterSale,
  setFilterSale,
  listDeviceType,
  listSales,
  search,
  setSearch,
  setSearchInput,
  setPage,
  isAdmin,
  isAccountant,
  isSale,
  setIsEditing,
  setEditOrderId,
  setForm,
  setDevices,
  setSelectedUser,
  setOpenAddModal
}) => {
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const handleFilterClick = event => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const activeFilterCount = [
    filterType !== 'all',
    filterDevice !== 'all',
    filterSale !== 'all'
  ].filter(Boolean).length;

  return (
    <>

      <Card className={classes.toolbar}>
        <TextField
          id="search-orders"
          className={classes.searchInput}
          placeholder="Tìm theo tên, SĐT, công ty..."
          variant="outlined"
          size="small"
          value={searchInput}
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon fontSize="small" color="action">
                  <SearchIcon />
                </SvgIcon>
              </InputAdornment>
            ),
            endAdornment: searchInput ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => {
                    setSearchInput('');
                    setSearch('');
                    setPage(1);
                  }}
                >
                  <CloseIcon style={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
        />

        <TextField
          label="Từ ngày"
          type="date"
          placeholder="Từ ngày"
          variant="outlined"
          size="small"
          value={fromDate}
          onChange={e => {
            setFromDate(e.target.value);
            setPage(1);
          }}
          className={classes.filterSelect}
          InputLabelProps={{
            shrink: true,
            style: {
              backgroundColor: 'white',
              padding: '0 4px',
              marginLeft: -4
            }
          }}
          InputProps={{
            endAdornment: fromDate ? (
              <InputAdornment
                position="end"
                style={{ position: 'absolute', right: 28 }}
              >
                <IconButton
                  size="small"
                  onClick={() => {
                    setFromDate('');
                    setPage(1);
                  }}
                  style={{ padding: 2 }}
                >
                  <CloseIcon style={{ fontSize: 14 }} />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
        />

        <TextField
          label="Đến ngày"
          type="date"
          placeholder="Đến ngày"
          variant="outlined"
          size="small"
          value={toDate}
          onChange={e => {
            setToDate(e.target.value);
            setPage(1);
          }}
          className={classes.filterSelect}
          InputLabelProps={{
            shrink: true,
            style: {
              backgroundColor: 'white',
              padding: '0 4px',
              marginLeft: -4
            }
          }}
          InputProps={{
            endAdornment: toDate ? (
              <InputAdornment
                position="end"
                style={{ position: 'absolute', right: 28 }}
              >
                <IconButton
                  size="small"
                  onClick={() => {
                    setToDate('');
                    setPage(1);
                  }}
                  style={{ padding: 2 }}
                >
                  <CloseIcon style={{ fontSize: 14 }} />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
        />

        <Button
          variant="outlined"
          size="small"
          onClick={handleFilterClick}
          startIcon={<FilterListIcon />}
          style={{
            height: 40,
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 600,
            marginTop: -3,
            color: activeFilterCount > 0 ? '#D9042F' : '#666',
            borderColor: activeFilterCount > 0 ? '#D9042F' : '#e0e3ef',
            backgroundColor: activeFilterCount > 0 ? '#fff1f0' : 'white'
          }}
        >
          Lọc {activeFilterCount > 0 ? `(${activeFilterCount})` : ''}
        </Button>

        <Popover
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          PaperProps={{
            style: {
              padding: 20,
              width: 300,
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
              borderRadius: 12,
              marginTop: 8,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
            }
          }}
        >
          <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
            Bộ lọc bổ sung
          </Typography>

          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel
              id="type-label"
              style={{
                backgroundColor: 'white',
                padding: '0 4px',
                marginLeft: -4
              }}
            >
              Loại khách
            </InputLabel>
            <Select
              labelId="type-label"
              id="filter-type"
              value={filterType}
              onChange={handleTypeChange}
              label="Loại khách"
            >
              <MenuItem value="all">Tất cả</MenuItem>
              <MenuItem value="Người dùng">Người dùng</MenuItem>
              <MenuItem value="Đại lý">Đại lý</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel
              id="device-label"
              style={{
                backgroundColor: 'white',
                padding: '0 4px',
                marginLeft: -4
              }}
            >
              Loại Thiết bị
            </InputLabel>
            <Select
              labelId="device-label"
              id="filter-device"
              value={filterDevice}
              onChange={e => {
                setFilterDevice(e.target.value);
                setPage(1);
              }}
              label="Loại Thiết bị"
            >
              <MenuItem value="all">Tất cả</MenuItem>
              {(listDeviceType || []).map(d => (
                <MenuItem key={d.id} value={d.id}>
                  {d.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {(isAdmin || isAccountant) && (
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel
                id="sale-label"
                style={{
                  backgroundColor: 'white',
                  padding: '0 4px',
                  marginLeft: -4
                }}
              >
                Nhân viên Sale
              </InputLabel>
              <Select
                labelId="sale-label"
                id="filter-sale"
                value={filterSale}
                onChange={e => {
                  setFilterSale(e.target.value);
                  setPage(1);
                }}
                label="Nhân viên Sale"
              >
                <MenuItem value="all">Tất cả</MenuItem>
                {(listSales || []).map(u => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.full_name || u.fullName || u.username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleFilterClose}
            style={{ textTransform: 'none', fontWeight: 600 }}
          >
            Áp dụng
          </Button>
        </Popover>

        {(fromDate ||
          toDate ||
          filterType !== 'all' ||
          filterDevice !== 'all' ||
          filterSale !== 'all' ||
          filterStatus !== 'all' ||
          search) && (
            <Tooltip title="Xóa tất cả bộ lọc">
              <IconButton
                size="small"
                onClick={() => {
                  setFromDate('');
                  setToDate('');
                  setFilterType('all');
                  setFilterDevice('all');
                  setFilterSale('all');
                  setFilterStatus('all');
                  setSearch('');
                  setSearchInput('');
                  setPage(1);
                }}
                style={{
                  color: '#D9042F',
                  border: '1px solid #D9042F33',
                  borderRadius: 8,
                  padding: 8,
                  height: 40,
                  width: 40,
                  marginTop: -3
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}

        {(isAdmin || isSale) && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setIsEditing(false);
              setEditOrderId(null);
              setForm({
                account: '',
                paymentMethod: 'Tiền mặt',
                type: '',
                simType: '',
                isNewOrder: '',
                note: '',
                fullName: '',
                phone: '',
                company: '',
                installationType: '',
                extra_fee: 0,
                vat: 8
              });
              setDevices([{ type: 'VGPS_CAM4G', quantity: 1, unitPrice: 0 }]);
              setSelectedUser(null);
              setOpenAddModal(true);
            }}
            style={{
              fontWeight: 600,
              height: 40,
              borderRadius: 8,
              marginLeft: 'auto'
            }}
          >
            + Lập phiếu bán hàng
          </Button>
        )}
      </Card>
    </>
  );
};

export default ToolbarSection;
